import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_GROUP_RESIT_REGISTRATION_START_PROCESSING } from '../../constants/apiUrls';
import { CandidateResitSubjectRequest } from './model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostStartProcessing = ({ onSuccess, onError }: Input = {}) => {
  const postStartProcessing = async (payload: {
    uuid: string;
    candidateResitSubjects: CandidateResitSubjectRequest[];
  }) => {
    const res = await axiosClient.post<void>(
      POST_GROUP_RESIT_REGISTRATION_START_PROCESSING(payload.uuid),
      payload.candidateResitSubjects
    );
    return res.data;
  };

  return useCustomMutation(postStartProcessing, {
    onSuccess,
    onError,
  });
};
